/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

import { BaseAttachmentDTO } from '@well/attachment/domain';
import { DocumentVoModel } from './document-vo.model';
import { DocumentStatusModel } from './document-status.model';

export class DocumentEntryDtoModel extends JSONable{
  uuid: string | undefined
  documentVO: DocumentVoModel | undefined
  issueDate: string | undefined
  expirationDate: string | undefined
  obs: string | undefined
  active: DocumentStatusModel | undefined
  documentAttachmentDTOS: BaseAttachmentDTO[] = []
  ownerOfDocumentUuid: string | undefined
}
